import React from 'react';
import { connect } from 'react-redux';
import { mapDispatchToProps, mapStateToProps, Props } from 'component/page/detail/Review/ReviewOverlay/ReviewOverlay.selectors';
import { Box, FullScreenSheet, Icon, Typography } from '@drone-js/core';
import ReviewListContainer from 'component/page/detail/Review/ReviewList/ReviewListContainer';

const ReviewOverlay: React.FC<Props> = (props) => {
    return (
        <FullScreenSheet visible={props.isReviewOverlayVisible} onClose={props.closeReviewOverlay} zIndex={1060}>
            <Box display="flex" position="sticky" top="0" backgroundColor="base.surface" flexDirection="column" boxShadow="bottom-s" px="16" pb="12" zIndex={1070}>
                <Box display="flex" alignItems="center" flexDirection="row" mt="16" mb="8">
                    <Box data-testid="activities-custom-sheet-close-button" as="button" width="fit-content" onClick={props.onClickBackReviewOverlay} p="0" pe="12">
                        <Icon id="fill.arrow.thin-left" size="20" label={props.cms[126815]} />
                    </Box>
                    <Typography variant="heading-default" data-testid="review-overlay-header">
                        {props.cms[102057]}
                    </Typography>
                </Box>
            </Box>
            <Box px="16" pb="12" pt="8" width="100%" maxWidth="744px" mx="auto">
                {!props.isError && (
                    <Typography variant="heading-l" textColor="base.default" mb="12" data-testid="overall-rating-heading" pt="12">
                        {props.cms[276869]}
                    </Typography>
                )}
                <ReviewListContainer isInOverlay={true} />
            </Box>
        </FullScreenSheet>
    );
};
ReviewOverlay.displayName = 'ReviewsOverlay';

export default connect(mapStateToProps, mapDispatchToProps)(ReviewOverlay);
